import { Theaters } from '@mui/icons-material';
import { GuardedComponents } from '../../lib/permissions/types';
import { ResourceDefinition } from '../types';
import { VideoList, VideoEdit, VideoCreate } from '.';

export default {
  permissionResource: 'Video',
  name: 'videos',
  icon: Theaters,
  components: new GuardedComponents([
    ['list', { action: 'GetList', component: VideoList }],
    ['edit', { action: 'Update', component: VideoEdit }],
    ['create', { action: 'Create', component: VideoCreate }],
  ]),
  i18n: {
    nl: {
      name: 'Video |||| Videos',
      fields: {
        createdAt: 'Aangemaakt op',
        'createdBy.name': 'Aangemaakt door',
        title: 'Titel',
        'lto.name': 'LTO',
        preview: 'Voorbeeld',
        publishedAt: 'Gepubliceerd op',
      },
    },
  },
} as ResourceDefinition;
